<template>
    <button v-if="!editable" type="button" class="uk-button uk-button-primary uk-width-1-1" @click.prevent="reset_password">Reset Password</button>
    <div v-else>
        <button v-if="seconds_left<=0" type="button" class="uk-button uk-button-primary uk-width-1-1" @click.prevent="edit">Change Password...</button>
        <div v-else class="uk-width-1-1">
            <div class="uk-field-group uk-width-1-1">
                <input ref="password-field" type="text" v-model="password" placeholder="Enter your new password..." class="uk-width-6-10" @keyup="reset_countdown" />
                <a href class="uk-button" @click.prevent="cancel">
                    <open-icon glyph="remove" />
                </a>
                <a class="uk-button" @click.prevent="save">
                    <open-icon glyph="save" />
                </a>
            </div>
            <small>For security purposes, the operation will be cancelled in {{ seconds_left }} seconds</small>
        </div>
    </div>
</template>

<script type="text/javascript">
import notifies from "../../mixins/Notifies"

import OpenIcon from "../../ui/OpenIcon"

export default {
    mixins: [notifies],
    components: {
        OpenIcon
    },
    methods: {
        countdown () {
            this.timer = setTimeout(() => {
                if(--this.seconds_left > 0) this.countdown()
            }, 1000)
        },
        cancel_countdown () {
            if(this.timer) {
                clearTimeout(this.timer)
                this.timer = null
            }
        },
        reset_countdown () {
            this.cancel_countdown()
            this.seconds_left = 5
            this.countdown()
        },
        reset_password () {
            this.$store.dispatch("SEND_PASSWORD_RESET", {
                email: this.record.email
            }).then(data => {
                if(data.error) {
                    this.$error(data.error.message)
                } else {
                    this.$success(data.message, "success")
                }
            }).catch(error => {
                this.$error(error.message)
            })
        },
        edit (dont_select) {
            this.reset_countdown()
            this.$nextTick(() => {
                this.$refs["password-field"].focus()
                if(!dont_select) this.$refs["password-field"].select()
            })
        },
        cancel () {
            this.seconds_left = 0
            this.password = ""
        },
        save () {
            this.cancel_countdown()
            if(!this.password || (this.password.length < 6)) {
                this.$error("Invalid Password: Please set-up a password of at least 6 characters.")
                this.edit(true)
            } else {
                this.$store.dispatch("RECORD_SAVE", {
                    entity: "user",
                    id: this.record.id,
                    data: { password: encodeURIComponent(this.password) }
                }).then(() => {
                    this.$success("The password was successfully changed.")
                    this.cancel()
                }).catch(error => {
                    this.$error(error.message)
                    this.edit()
                })
            }
        }
    },
    computed: {
    },
    props: {
        record: {
            required: true
        },
        editable: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            seconds_left: 0,
            timer: null,
            password: ""
        }
    }
}
</script>
